import styled from 'styled-components'

export const Container = styled.div`
    input {
        display: block;
        height: calc(2.25rem + 2px);
        padding: 0.375rem 0.75rem;
        font-size: 1rem;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        position: relative;
        -ms-flex: 1 1 auto;
        flex: 1 1 auto;
        width: 1%;
        margin-bottom: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;

        &:focus {
            color: #495057;
            background-color: #fff;
            border-color: #80bdff;
            outline: 0;
            box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%);
        }
    }
`

export const Tag = styled.div`
    background-color: ${(props) => {return props.theme.colorPrimary}};
    color: #fffe;
    font-size: .7rem;
    margin: 10px 3px 0;
    padding: 5px 10px 3px;
    border-radius: 10px;
    display: inline-block;

    i {
        cursor: pointer;
    }
`
